import { useTheme } from "@emotion/react";
import { Typography } from "@fullscript/aviary-web";
import { useTranslation } from "react-i18next";

import { SvgFullscriptLogo, SvgFullscriptLogoDarkTextGreenLeaf } from "@shared/assets/logo";
import { l } from "@unauthenticated/signupSignin/locales/i18n";

import * as styles from "./PoweredByFullscript.styles";

const PoweredByFullscript = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  const isDark = theme.theme === "dark";

  return (
    <span css={styles.poweredBy} role="img" aria-label={t(l.patientRxAuth.PoweredByFullscript)}>
      <Typography variant="footnote" as="span" isMarginless colorIntensity="subtle">
        {t(l.patientRxAuth.PoweredBy)}
      </Typography>
      {isDark ? (
        <SvgFullscriptLogo css={styles.poweredByLogo} />
      ) : (
        <SvgFullscriptLogoDarkTextGreenLeaf css={styles.poweredByLogo} />
      )}
    </span>
  );
};

export { PoweredByFullscript };
